















import { defineComponent, computed } from "@vue/composition-api";
import { AbsBox } from "@ui";

export default defineComponent({
	props:{
		value:{
			type:Boolean,
			default:false,
		}
	},
	components: {
		AbsBox,
	},
	setup(props, ctx){
		const show = computed({
			get:() => props.value,
			set: v => ctx.emit("input", v)
		});
		return {
			show,
		};
	}
});

